/*
 * Cart terms & conditions gate.
 * - The `required` checkbox inside each checkout form is the hard gate for the
 *   standard checkout button (native browser validation, survives re-renders).
 * - This script gates the express / dynamic checkout buttons, which live outside
 *   the form, by keeping them hidden until the matching checkbox is ticked, and
 *   adds a visual disabled state + error highlight for feedback.
 */
(function () {
  if (window.__cartTermsInit) return;
  window.__cartTermsInit = true;

  function checkboxFor(group) {
    return document.querySelector('[data-cart-terms-checkbox][data-terms-group="' + group + '"]');
  }

  function accepted(group) {
    var cb = checkboxFor(group);
    return cb ? cb.checked : true;
  }

  function sync(group) {
    var ok = accepted(group);
    document
      .querySelectorAll('[data-cart-terms-gate][data-terms-group="' + group + '"]')
      .forEach(function (el) {
        if (el.tagName === 'BUTTON') {
          el.classList.toggle('is-terms-disabled', !ok);
        } else {
          // Express / dynamic checkout buttons wrapper.
          el.classList.toggle('is-terms-ok', ok);
        }
      });
    if (ok) {
      var wrap = document.querySelector('[data-cart-terms][data-terms-group="' + group + '"]');
      if (wrap) wrap.classList.remove('cart-terms--error');
    }
  }

  function flag(group) {
    var wrap = document.querySelector('[data-cart-terms][data-terms-group="' + group + '"]');
    if (wrap) wrap.classList.add('cart-terms--error');
    var cb = checkboxFor(group);
    if (cb && cb.focus) cb.focus();
  }

  // Toggle state when a terms checkbox changes.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-cart-terms-checkbox]')) {
      sync(t.getAttribute('data-terms-group'));
    }
  });

  // Block clicks on gated buttons while unaccepted (belt-and-suspenders on top of
  // the native `required` validation), and flag the checkbox.
  document.addEventListener(
    'click',
    function (e) {
      var gate = e.target.closest && e.target.closest('[data-cart-terms-gate]');
      if (!gate) return;
      var group = gate.getAttribute('data-terms-group');
      if (!accepted(group)) {
        e.preventDefault();
        e.stopPropagation();
        flag(group);
      }
    },
    true
  );

  // Apply initial / post-render state.
  function initAll() {
    document.querySelectorAll('[data-cart-terms-checkbox]').forEach(function (cb) {
      sync(cb.getAttribute('data-terms-group'));
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Note: when the cart drawer / cart page re-render on quantity changes, the
  // server re-renders the checkbox unchecked and the button/express wrappers with
  // their default gated classes, so the gate re-applies itself without extra work.
})();
